import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

const Destinations = () => {
    const [title, setTitle] = useState("Agregar Destino");
    const [loading, setLoading] = useState(false);
    const [destination_id, setDestinationId] = useState(0);
    const [name, setName] = useState('');
    const [abbreviation, setAbbreviation] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [destinations, setDestinations] = useState([]);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [status_filter, setStatusFilter] = useState(2);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAll();
        setTimeout(() => {
            $('.select2').select2({ width: "100%", placeholder: "Seleccione" });
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activo', value: 1 },
        { label: 'Inactivo', value: 0 }
    ];

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        await axios.get(ENDPOINT + "get-all-destinations/" + status_filter).then((response) => {
            setDestinations(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: true,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por destino",
                    },
                });
                setLoading(false);
            }, 100);
        })
        .catch(function (error) {
            setLoading(false);
            console.log(error);
        });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("name", name);
        form.append("abbreviation", abbreviation);
        form.append("latitude", latitude);
        form.append("longitude", longitude);
        if (destination_id === 0) {
            await axios
                .post(ENDPOINT + "save-destination", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-destination/" + destination_id, {
                    name: name,
                    abbreviation: abbreviation,
                    latitude: latitude,
                    longitude: longitude
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setDestinationId(0);
        setName('');
        setAbbreviation('');
        setLatitude('');
        setLongitude('');
        setTitle("Agregar Destino");
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-destination-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-destination/" + id)
            .then((response) => {
                setLoading(false);
                setDestinationId(response.data.data.destination_id);
                setName(response.data.data.name);
                setAbbreviation(response.data.data.abbreviation);
                setLatitude(response.data.data.latitude);
                setLongitude(response.data.data.longitude);
                setTitle("Editar Destino");
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-destination/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const status_filter = $("#status_filter").val();
        const response = await axios.get(ENDPOINT + 'print-pdf-destinations/' + status_filter, { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        setLoading(false);
    };

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default"  data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                {destination_id === 0 ? <i className="fas fa-plus-circle me-2"></i> : <i className="fas fa-edit me-2"></i>}
                                {title}
                            </h4>
                            <button onClick={clearField} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="destinations-form-header">
                                    <h3 className="destinations-form-title">Información del Destino</h3>
                                    <p className="destinations-form-subtitle">Complete los datos del destino para la gestión del sistema</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-8">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-form-label col-form-label-sm">
                                                Destino <span className="destinations-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese el nombre del destino"
                                                id="name"
                                                name="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                            <small className="destinations-field-hint">Nombre completo del destino</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="abbreviation" className="col-form-label col-form-label-sm">
                                                Abreviación <span className="destinations-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese abreviación"
                                                id="abbreviation"
                                                name="abbreviation"
                                                value={abbreviation}
                                                onChange={(e) => setAbbreviation(e.target.value)}
                                                required
                                            />
                                            <small className="destinations-field-hint">Código corto del destino</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="latitude" className="col-form-label col-form-label-sm">
                                                Latitud <span className="destinations-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese la latitud"
                                                id="latitude"
                                                name="latitude"
                                                value={latitude}
                                                onChange={(e) => setLatitude(e.target.value)}
                                                required
                                            />
                                            <small className="destinations-field-hint">Coordenada geográfica (latitud)</small>
                                        </div>
                                    </div>  
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="longitude" className="col-form-label col-form-label-sm">
                                                Longitud <span className="destinations-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese la longitud"
                                                id="longitude"
                                                name="longitude"
                                                value={longitude}
                                                onChange={(e) => setLongitude(e.target.value)}
                                                required
                                            />
                                            <small className="destinations-field-hint">Coordenada geográfica (longitud)</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer destinations-form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {destination_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    onClick={clearField}
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Destinos" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-pin-map	me-2"></i> Listado de Destinos
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="destinations-indications row mb-4">
                            <div className="col-md-4 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="destinations-field-hint">Estado para filtrar los destinos</small>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button" >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                            <div className="col-xs-2 col-md-4">
                                <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="text-center">
                                                <td className="indications-table" width="30%" >Total</td>
                                                <td className="indications-table" width="30%" >Activos</td>
                                                <td className="indications-table" width="30%" >Inactivos</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TuserT">{active + inactive}</td>
                                                <td id="TuserA">{active}</td>
                                                <td id="TuserI">{inactive}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Destino</th>
                                    <th className="text-center">Abreviación</th>
                                    <th className="text-center">Latitud</th>
                                    <th className="text-center">Longitud</th>
                                    <th className="text-center">Estado</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {destinations.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.destination_id}</kbd>
                                        </td>
                                        <td>
                                            {item.name}
                                        </td>
                                        <td className="text-center">
                                            {item.abbreviation}
                                        </td>
                                        <td className="text-center">
                                            {item.latitude}
                                        </td>
                                        <td className="text-center">
                                            {item.longitude}
                                        </td>
                                        <td className="text-center">
                                            <div data-bs-toggle="tooltip" data-bs-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.destination_id)}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <span
                                                    title="Editar registro"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        className="btn-sm btn btn-warning me-1"
                                                        onClick={() => handleEdit(item.destination_id)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Eliminar registro"
                                                    className="btn-sm btn btn-danger me-1"
                                                    onClick={() => handleDelete(item.destination_id, item.name)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Destinations;